export default __webpack_public_path__ + "static/media/infernal_2.39d97337.png";